import React, { Component } from 'react';
import reactGA from 'react-ga';
import './Steps.css';
import API from '../services/api';

class Step6 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      stepNumber: 6,
      fields: {
        lookingForText: '',
        headline: '',
        aboutMe: ''
      },
      errors: {
        refCode: '',
        headline: '',
      },
    };
  }

  allFieldsFilled() {
    const emptyFields = Object.keys(this.state.fields).filter(field => {
      if (field !== 'refCode') {
        return this.state.fields[field].length === 0;
      } else {
        return false;
      }
    });
    return emptyFields.length === 0;
  }

  handleFieldChange(e, name) {
    let { fields, errors } = this.state;

    if(name === 'refCode') {
      errors.refCode = '';
    }

    if(name === 'headline') {
      errors.headline = '';
      if(e.target.value.length > 100) {
        errors.headline = 'Headline should be max 100 characters long';
      }
    }
    fields[name] = e.target.value;

    this.setState({ fields, errors });
  }

  handleNext(e) {
    e.preventDefault();
    const { fields } = this.props;
    let label = 'Sugar ';
    if(fields.accountType === 'sugar_parent') {
      if(fields.sex === 'F') {
        label += 'Mama';
      } else {
        label += 'Daddy';
      }
    } else {
      label += 'Baby ';
      if(fields.sex === 'F') {
        label += '(female)';
      } else {
        label += '(male)';
      }
    }
    reactGA.event({category: 'signup', action: 'out for confirmation', label});
    this.props.saveData(this.state.fields, true);
  }

  handleRefCodeBlur(e) {
    const { errors } = this.state;
    (new API()).post('/check-refCode', {refCode: e.target.value})
      .then(response => {
        if(!response.success) {
          errors['refCode'] = 'This promocode is invalid.';
            this.setState({
              errors,
            })
        }
      });
  }

  render() {
    const { fields } = this.props;
    const { errors } = this.state;
    return (
      <div className={`Step Step-container ${(this.props.active)?'active':''}`}>
        <div className="Step-title">
          Let's finish!
        </div>
        <ul className="steps">
          <li className="step-number done">1</li>
          <li className="step-number done">2</li>
          <li className="step-number done">3</li>
          <li className="step-number done">4</li>
          <li className="step-number done">5</li>
          <li className="step-number done">6</li>
        </ul>
        <div className="field-container text open">
          <div className="field-title">Headline:</div>
          <div className="row">
            <div className="col">
              <input onChange={e => this.handleFieldChange(e, e.target.name)} type="text" name="headline" placeholder="Make it stand out..." />
              {errors.headline.length > 0 && <span className="error">{errors.headline}</span>}
            </div>
          </div>
        </div>
        <div className="field-container text open">
          <div className="field-title">About me:</div>
          <div className="row">
            <div className="col">
              <textarea  rows="4" onChange={e => this.handleFieldChange(e, e.target.name)} type="text" name="aboutMe" placeholder="Tell something about yourself..." />
            </div>
          </div>
        </div>
        <div className="field-container text open">
          <div className="field-title">What I'm looking for:</div>
          <div className="row">
            <div className="col">
              <textarea  rows="4" onChange={e => this.handleFieldChange(e, e.target.name)} type="text" name="lookingForText" placeholder="What do you expect from an arrangement, what are you interested in?" />
            </div>
          </div>
        </div>
        {fields.accountType === 'sugar_parent' && <div className={`field-container text open`}>
          <div className="field-title">Promocode:</div>
          <div className="row">
            <div className="col">
              <input onBlur={e => {this.handleRefCodeBlur(e)}} onChange={e => this.handleFieldChange(e, e.target.name)} type="text" name="refCode" placeholder="Your Promocode..." defaultValue={fields.refCode} />
              {errors.refCode.length > 0 && <span className="error">{errors.refCode}</span>}
            </div>
          </div>
        </div>}
        <div className="terms-text">
          By continuing you agree to <a href="https://upperclassdates.com/terms/">UpperClassDates Terms</a> and <a href="https://upperclassdates.com/privacy-statement/">Privacy Policy</a>. Promoting illegal commercial activities (such as prostitution) is strictly prohibited and will result in a ban. Users must be at least 18 years old.
        </div>
        <div className="row button-container space-between">
          <button
            className="btn btn-primary"
            onClick={(e) => {e.preventDefault();this.props.back(this.state.stepNumber);}}
          >
            Back
          </button>
          <button
            className="btn btn-primary"
            disabled={!this.allFieldsFilled()}
            onClick={(e) => this.handleNext(e)}
          >
            Next
          </button>
        </div>
      </div>
    );
  }
}

export default Step6;


// WEBPACK FOOTER //
// ./src/components/Step6.js